import { Mods, mods } from '@approvalmax/theme';
import { LoadingBar } from '@approvalmax/ui';
import { StyledMods } from '@styled-kit/mods';
import { font } from 'modules/styles';
import styled from 'styled-components';

export const Root = styled.div`
    display: flex;
    flex-flow: column;
    align-items: center;
`;

export const LogoContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const TitleLine = styled.div`
    display: flex;
    align-items: center;
    margin-top: 21px;
`;

export const Title = styled.div`
    ${font(16, '#000', 'standard')};
    text-align: center;
`;

export const StyledLoadingBar = styled(LoadingBar)<StyledMods<Mods<'active'>>>`
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    opacity: 0;
    transition: opacity 300ms ease-in-out;

    ${mods.active.true`
        opacity: 1;
    `};
`;
